import React from 'react';
import { observer } from 'mobx-react-lite';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { useAddEmployeesPageStore } from 'store/pages/enrollment/add-employees/pageStore';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import { AlertStyled, BypassWarningMessageStyled, ConfirmationBlobStyled } from './styles';

export const CensusBypassSection: React.FC = observer(() => {
  const {
    bypassModalDelegate: {
      isVisible,
      showBypassBlockedAlert,
      totalEmployees,
      isModalLoading,
      open,
      close,
      confirmBypass,
    },
  } = useAddEmployeesPageStore();

  const employeeLabel = totalEmployees === 1 ? 'employee' : 'employees';

  return (
    <>
      <ConfirmationBlobStyled
        title="Bypass Employee Setup"
        message={
          <>
            If employees are not needed for this quote, you can bypass this step without adding them. <br /> The
            Employee Elections step will be skipped automatically.
          </>
        }
        btnText="Bypass Step"
        onConfirm={open}
      />
      <ActionModal
        show={isVisible}
        onClose={close}
        title="Bypass Employee Setup"
        subtitle={
          <>
            You are about to skip employee setup. <br />
            The Employee Elections step will be skipped automatically
          </>
        }
        modalContent={
          showBypassBlockedAlert ? (
            <AlertStyled
              content={[
                <BypassWarningMessageStyled key="bypass-warning-message">
                  Bypass is unavailable because <b>{`${totalEmployees} ${employeeLabel}`}</b> have already been added.
                  Remove them or complete the step instead.
                </BypassWarningMessageStyled>,
              ]}
              title="Error"
              type="error"
            />
          ) : null
        }
        actionButtonText="Bypass Step"
        closeButtonText="Cancel"
        onAction={confirmBypass}
        loading={isModalLoading}
        isValid={totalEmployees === 0 && !isModalLoading}
        modalType={ModalType.NOTIFICATION}
      />
    </>
  );
});
